/* eslint-disable no-unused-expressions */
/* eslint-disable react/sort-comp */
/* eslint-disable jsx-a11y/alt-text */
import React, { Component, Fragment } from 'react';
import { connect } from 'react-redux';
import { Link, withRouter } from 'react-router-dom';
import PropTypes from 'prop-types';
import {
  Table, Checkbox, Button, Drawer, Switch,
} from 'antd';
import { CloseOutlined } from '@ant-design/icons';
import H3Text from '@Uilib/h3Text';
import H3FormInput from '@Uilib/h3FormInput';
import './style.scss';
import { QUANTITY } from '@Apis/constants';
import H3Image from '@Uilib/h3Image';
import closeIcon from '@Images/icons/icon-close-blue.png';
import BatchesList from '@Components/Common/BatchesList';

/**
 * RefundLines component
 *
 * @param record
 * @param file
 */
class RefundLines extends Component {
  /**
   * Constructor
   *
   * @param props
   */
  constructor(props) {
    super(props);
    this.state = {
      toggleRejectedBatches: false,
      fulfillmentLinesColumns: [
        {
          title: 'SKU#',
          render: (item) => (
            <Fragment>
              <Link to={`/inventory/product/view/${item?.product_sku_info?.product_sku_id}`} target="_blank">
                {item?.product_sku_info?.internal_sku_code}
              </Link>
              <H3Text text={item.remarks} className="quotation__remarks" />
            </Fragment>
          ),
        },
        {
          title: 'PRODUCT',
          width: '220px',
          render: (item) => (
            <Fragment>
              {item?.product_sku_info?.product_sku_name}
              <H3Text text={item.remarks} className="quotation__remarks" />
            </Fragment>
          ),
        },
        {
          title: 'PENDING QTY',
          width: '100px',
          render: (text, record) => `${QUANTITY(record?.ordered_quantity, record?.uom_info?.[0]?.precision)} ${record?.uom_info?.[0]?.uqc.toProperCase()}`,
        },
        {
          title: 'QUANTITY',
          dataIndex: 'quantity',
          width: '220px',
          render: (text, record) => {
            const {
              formSubmitted, updateData, data, handleQuantityChange,
            } = this.props;
            return (
              <div>
                <div style={{ width: '100%' }}>
                  <H3FormInput
                    value={record.quantity}
                    type="number"
                    containerClassName={`orgInputContainer ${(formSubmitted && ((Number(record.quantity) <= 0) || (Number(record.quantity) > Number(record?.ordered_quantity)))) ? 'create-pr__input' : ''}`}
                    labelClassName="orgFormLabel"
                    inputClassName="orgFormInput"
                    onWheel={(event) => event.target.blur()}
                    onChange={(event) => {
                      const copyData = JSON.parse(JSON.stringify(data));
                      const updatedData = copyData.map((obj) => {
                        if (obj.key === record.key) {
                          return { ...obj, quantity: event.target.value };
                        }
                        return obj;
                      });
                      updateData(updatedData);
                      handleQuantityChange(updatedData);
                    }}
                    // disabled={record?.product_sku_info?.product_type?.toUpperCase() === 'SERVICE' ? false : !Helpers.getValueTotalInObject(record?.product_batches?.filter((item) => item?.batch_in_use), 'available_qty')}
                  />
                  <div className="inv-qty-input-uom">{record?.uom_info?.uqc?.toProperCase()}</div>
                </div>

              </div>
            );
          },
        },
        {
          title: 'RESTOCK',
          dataIndex: 'quantity',
          width: '120px',
          render: (text, record) => {
            const { formSubmitted, updateData, data } = this.props;
            return (
              <Fragment>
                {record?.product_sku_info?.product_type !== 'BUNDLE' ? (
                  <div style={{ width: '100%' }}>
                    <Checkbox
                      checked={record.restock}
                      onChange={(event) => {
                        const copyData = JSON.parse(JSON.stringify(data));
                        const updatedData = copyData.map((obj) => {
                          if (obj.key === record.key) {
                            return { ...obj, restock: event.target.checked };
                          }
                          return obj;
                        });
                        updateData(updatedData);
                      }}
                      style={{ marginLeft: '40%' }}
                    />
                  </div>
                ) : '-'}
              </Fragment>
            );
          },
        },
        {
          title: 'INWARDS BATCH',
          render: (item) => {
            const { formSubmitted, selectedAdjustmentType } = this.state;
            const showError = formSubmitted && !item?.selectedBatch;
            return (
              <Fragment>
                {item?.product_sku_info?.product_type !== 'BUNDLE' && item?.restock ? (
                  <Fragment>
                    <Button
                      style={{
                        fontSize: '12px',
                        height: '35px',
                      }}
                      className={(showError) ? 'input-select-error' : 'default'}
                      onClick={() => {
                        this.setState({
                          showLineBatches: true,
                          productBatches: item?.product_batches,
                          selectedLineInfo: {
                            expiryDays: item?.expiryDays,
                            batchUom: item?.product_sku_info?.uom_info,
                            selectedBatch: item?.selectedBatch,
                            uomList: item?.product_sku_info?.uom_list,
                            tenantProductId: item?.product_sku_info?.tenant_product_id,
                            nextBatchCode: item?.nextBatchCode,
                            key: item?.key,
                          },
                        });
                      }}
                    >
                      {item?.restock && item?.selectedBatch ? item?.selectedBatch?.custom_batch_number || item?.selectedBatch?.batch_number : 'Select Batch'}
                    </Button>
                    {formSubmitted && !item?.selectedBatch && (
                      <div className="input-error">
                        *Please select a batch
                      </div>
                    )}
                    <H3Text text="" className="create-grn__qty" />
                  </Fragment>
                ) : '-'}
              </Fragment>
            );
          },
          responsive: ['sm', 'md', 'lg', 'xxl'],
        },
        {
          title: 'PRICE',
          render: (record) => (
            <React.Fragment>
              {this.props.MONEY(record.offer_price)}
            </React.Fragment>
          ),
        },
        {
          title: 'TAX',
          render: (record) => {
            const { soMapping } = this.props;
            return (
              <Fragment>
                {`${record?.tax_info?.tax_value }%`}
              </Fragment>
            );
          },
        },
        {
          title: 'LINE TOTAL',
          render: (text, record) => {
            const unitPrice = record?.offer_price;
            const taxValue = record?.tax_info?.tax_value;
            return (
              <H3Text text={(record.quantity && (taxValue) >= 0) ? this.props.MONEY((record.quantity * unitPrice * (1 + (taxValue) / 100))) : '0'} />
            );
          },
        },
        {
          title: '',
          render: (text, record) => {
            const { handleDelete, data } = this.props;
            return (
              <Fragment>
                {data.length !== record.key && (
                  <div className="update-invoice__delete-line-button" onClick={() => handleDelete(record.key)}>
                    <CloseOutlined />
                  </div>
                )}
              </Fragment>
            );
          },
          width: '40px',
        },
      ],
    };
  }

  getbundliListColumn = () => {
    const bundleListColumns = [
      {
        title: 'SKU#',
        render: (record) => (
          <Link to={`/inventory/product/view/${record?.product_sku_info?.product_sku_id}`} target="_blank">
            {record?.product_sku_info?.internal_sku_code}
          </Link>
        ),
      },
      {
        title: 'PRODUCT',
        render: (text, record) => (
          <div className="so-table__product-name">
            {record?.product_sku_info?.product_sku_name}
          </div>
        ),
      },
      {
        title: 'QUANTITY',
        dataIndex: 'quantity',
        render: (text, record) => (
          <div className="so-qty-input">
            {`${record?.bundle_quantity} ${record?.product_sku_info?.uom_info?.uqc?.toProperCase()}`}
          </div>
        ),
      },
      {
        title: 'RESTOCK',
        dataIndex: 'quantity',
        width: '120px',
        render: (text, record) => {
          const { formSubmitted, updateData, data } = this.props;
          return (
            <Fragment>
              {record?.product_sku_info?.product_type !== 'BUNDLE' ? (
                <div style={{ width: '100%' }}>
                  <Checkbox
                    checked={record.restock}
                    onChange={(event) => {
                      const copyData = JSON.parse(JSON.stringify(data));
                      for (let i = 0; i < copyData?.length; i++) {
                        const copyDataItem = copyData[i];
                        if (copyDataItem?.key === record?.parentKey) {
                          for (let j = 0; j < copyDataItem?.bundle_products?.length; j++) {
                            const bundleProduct = copyDataItem?.bundle_products[j];
                            if (bundleProduct?.key === record?.key) {
                              bundleProduct.restock = event.target.checked;
                            }
                          }
                        }
                      }
                      updateData(copyData);
                    }}
                  />
                </div>
              ) : '-'}
            </Fragment>
          );
        },
      },
      {
        title: 'INWARDS BATCH',
        render: (item) => {
          const { formSubmitted } = this.props;
          const showError = formSubmitted && !item?.selectedBatch;
          return (
            <Fragment>
              <Button
                style={{
                  fontSize: '12px',
                  height: '35px',
                }}
                className={(showError) ? 'input-select-error' : 'default'}
                onClick={() => {
                  this.setState({
                    showLineBatches: true,
                    productBatches: item?.product_batches,
                    selectedLineInfo: {
                      expiryDays: item?.expiryDays,
                      batchUom: item?.product_sku_info?.uom_info,
                      selectedBatch: item?.selectedBatch,
                      uomList: item?.product_sku_info?.uom_list,
                      tenantProductId: item?.product_sku_info?.tenant_product_id,
                      nextBatchCode: item?.nextBatchCode,
                      key: item?.key,
                      parentKey: item?.parentKey,
                    },
                  });
                }}
              >
                {item?.selectedBatch ? item?.selectedBatch?.custom_batch_number || item?.selectedBatch?.batch_number : 'Select Batch'}
              </Button>
              {formSubmitted && !item?.selectedBatch && (
                <div className="input-error">
                  *Please select a batch
                </div>
              )}
              <H3Text text="" className="create-grn__qty" />
            </Fragment>
          );
        },
        responsive: ['sm', 'md', 'lg', 'xxl'],
      },
    ];

    return bundleListColumns;
  };

  /**
   *
   */
  componentDidMount() {

  }

  /**
   *
   */
  setSelectedBatch(batch) {
    const { selectedLineInfo } = this.state;
    const { data, updateData } = this.props;
    const dataCopy = JSON.parse(JSON.stringify(data));

    for (let i = 0; i < dataCopy?.length; i++) {
      const productType = dataCopy[i]?.product_sku_info?.product_type;

      if (productType === 'BUNDLE') {
        for (let j = 0; j < dataCopy[i]?.bundle_products?.length; j++) {
          if (dataCopy[i].bundle_products[j]?.key === selectedLineInfo?.key) {
            dataCopy[i].bundle_products[j].selectedBatch = batch;
            this.setState({
              showLineBatches: false,
              productBatches: dataCopy[i].bundle_products[j]?.product_batches,
              selectedLineInfo: {
                expiryDays: dataCopy[i].bundle_products[j]?.expiryDays,
                batchUom: dataCopy[i].bundle_products[j]?.uom_info,
                selectedBatch: batch,
                uomList: dataCopy[i].bundle_products[j]?.uom_list,
                tenantProductId: dataCopy[i].bundle_products[j]?.tenant_product_id,
                key: dataCopy[i].bundle_products[j]?.key,
              },
            });
            break;
          }
        }
      } else if (dataCopy[i]?.key === selectedLineInfo?.key) {
        dataCopy[i].selectedBatch = batch;
        this.setState({
          showLineBatches: false,
          productBatches: dataCopy[i]?.product_batches,
          selectedLineInfo: {
            expiryDays: dataCopy[i]?.expiryDays,
            batchUom: dataCopy[i]?.uom_info,
            selectedBatch: batch,
            uomList: dataCopy[i]?.uom_list,
            tenantProductId: dataCopy[i]?.tenant_product_id,
            key: dataCopy[i]?.key,
          },
        });
        break;
      }
    }

    updateData(dataCopy);
  }

  /**
   *
   * @param batch
   */
  addNewBatch(batch, callback) {
    const { selectedLineInfo } = this.state;
    const { data, updateData } = this.props;
    const dataCopy = JSON.parse(JSON.stringify(data));

    for (let i = 0; i < dataCopy?.length; i++) {
      const productType = dataCopy[i]?.product_sku_info?.product_type;

      if (productType === 'BUNDLE') {
        for (let j = 0; j < dataCopy[i]?.bundle_products?.length; j++) {
          if (dataCopy[i]?.bundle_products[j]?.key === selectedLineInfo?.key) {
            dataCopy[i].bundle_products[j].selectedBatch = batch;
            dataCopy[i].bundle_products[j].product_batches = [
              batch || [],
              ...dataCopy[i]?.bundle_products[j]?.product_batches || [],
            ];
            this.setState({
              // showLineBatches: false,
              productBatches: dataCopy[i]?.bundle_products[j]?.product_batches,
              selectedLineInfo: {
                ...selectedLineInfo,
                expiryDays: dataCopy[i]?.bundle_products[j]?.expiryDays,
                batchUom: dataCopy[i]?.bundle_products[j]?.uom_info,
                selectedBatch: batch,
                uomList: dataCopy[i]?.bundle_products[j]?.uom_list,
                tenantProductId: dataCopy[i]?.bundle_products[j]?.tenant_product_id,
                key: dataCopy[i]?.bundle_products[j]?.key,
              },
            });
            break;
          }
        }
      } else if (dataCopy[i]?.key === selectedLineInfo?.key) {
        dataCopy[i].selectedBatch = batch;
        dataCopy[i].product_batches = [
          batch || [],
          ...dataCopy[i]?.product_batches || [],
        ];
        this.setState({
          // showLineBatches: false,
          productBatches: dataCopy[i]?.product_batches,
          selectedLineInfo: {
            ...selectedLineInfo,
            expiryDays: dataCopy[i]?.expiryDays,
            batchUom: dataCopy[i]?.uom_info,
            selectedBatch: batch,
            uomList: dataCopy[i]?.uom_list,
            tenantProductId: dataCopy[i]?.tenant_product_id,
            key: dataCopy[i]?.key,
          },
        });
        break;
      }
    }

    callback();
    updateData(dataCopy);
  }

  /**
   *
   * @param batch
   */
  removeNewBatch() {
    const { selectedLineInfo } = this.state;
    const { data, updateData } = this.props;
    const dataCopy = JSON.parse(JSON.stringify(data));

    for (let i = 0; i < dataCopy?.length; i++) {
      const productType = dataCopy[i]?.product_sku_info?.product_type;

      if (productType === 'BUNDLE') {
        for (let j = 0; j < dataCopy[i]?.bundle_products?.length; j++) {
          if (dataCopy[i]?.bundle_products[j]?.key === selectedLineInfo?.key) {
            dataCopy[i].bundle_products[j].selectedBatch = null;
            dataCopy[i].bundle_products[j].product_batches = [...dataCopy[i].bundle_products[j].product_batches?.filter((item) => item.batch_id)];
            this.setState({
              productBatches: dataCopy[i].bundle_products[j]?.product_batches,
              selectedLineInfo: {
                ...selectedLineInfo,
                expiryDays: dataCopy[i].bundle_products[j]?.expiryDays,
                batchUom: dataCopy[i].bundle_products[j]?.uom_info,
                selectedBatch: null,
                uomList: dataCopy[i].bundle_products[j]?.uom_list,
                tenantProductId: dataCopy[i].bundle_products[j]?.tenant_product_id,
                key: dataCopy[i].bundle_products[j]?.key,
              },
            });
            break;
          }
        }
      } else if (dataCopy[i]?.key === selectedLineInfo?.key) {
        dataCopy[i].selectedBatch = null;
        dataCopy[i].product_batches = [...dataCopy[i].product_batches?.filter((item) => item.batch_id)];
        this.setState({
          productBatches: dataCopy[i]?.product_batches,
          selectedLineInfo: {
            ...selectedLineInfo,
            expiryDays: dataCopy[i]?.expiryDays,
            batchUom: dataCopy[i]?.uom_info,
            selectedBatch: null,
            uomList: dataCopy[i]?.uom_list,
            tenantProductId: dataCopy[i]?.tenant_product_id,
            key: dataCopy[i]?.key,
          },
        });
        break;
      }
    }

    updateData(dataCopy);
  }

  /**
   *
   * @return {*}
   */
  render() {
    const {
      loading, data,
    } = this.props;
    const {
      fulfillmentLinesColumns, showLineBatches, productBatches, selectedLineInfo, toggleRejectedBatches,
    } = this.state;

    return (
      <Fragment>
        <div className="pr-table-wrapper hide__in-mobile">
          <Table
            bordered
            loading={loading}
            showHeader
            size="small"
            columns={fulfillmentLinesColumns}
            dataSource={data}
            pagination={false}
            expandable={{
              rowExpandable: (record) => record?.bundle_products?.length,
              defaultExpandAllRows: true,
              expandedRowRender: (record) => (
                <div className="view-bundle__inner-table">
                  <Table
                    bordered
                    showHeader
                    size="small"
                    columns={this.getbundliListColumn()}
                    dataSource={record?.bundle_products?.map((item) => ({
                      ...item,
                      bundle_quantity: parseFloat(item?.quantity || '0'),
                    }))}
                    pagination={false}
                  />
                </div>
              ),
            }}
          />
        </div>
        <Drawer
          open={showLineBatches}
          onClose={() => this.setState({ showLineBatches: false })}
          width="400px"
          destroyOnClose
        >
          <div className="custom-drawer__header-wrapper">
            <div className="custom-drawer__header" style={{ width: '355px' }}>
              <H3Text text={`${productBatches?.length || '0'} Available Batches`} className="custom-drawer__title" />
              <H3Image src={closeIcon} className="custom-drawer__close-icon" onClick={() => this.setState({ showLineBatches: false })} />
            </div>
          </div>
          <div className="batch-list__status-toggle">
            Show rejected batches

            <Switch style={{ marginLeft: '10px' }} onChange={() => { this.setState({ toggleRejectedBatches: !toggleRejectedBatches }); }} />
          </div>
          <BatchesList
            batches={!toggleRejectedBatches ? productBatches : productBatches?.filter((obj) => obj.is_rejected_batch === null)}
            expiryDays={selectedLineInfo?.expiryDays}
            expiryDate={selectedLineInfo?.expiryDate}
            batchUom={selectedLineInfo?.batchUom}
            selectedBatch={selectedLineInfo?.selectedBatch}
            uomList={selectedLineInfo?.uomList}
            tenantProductId={selectedLineInfo?.tenantProductId}
            setSelectedBatch={(batch) => this.setSelectedBatch(batch)}
            onAddNewBatch={(batch, callback) => this.addNewBatch(batch, callback)}
            removeNewBatch={() => this.removeNewBatch()}
            // destDepartmentId={userTenantDepartmentId}
            nextBatchCode={selectedLineInfo?.nextBatchCode}
          />
        </Drawer>
      </Fragment>
    );
  }
}

const mapStateToProps = ({ UserReducers }) => ({
  MONEY: UserReducers.MONEY,
});

const mapDispatchToProps = (dispatch) => ({

});

RefundLines.propTypes = {
  formSubmitted: PropTypes.any,
  updateData: PropTypes.any,
  data: PropTypes.any,
  loading: PropTypes.bool,
  handleDelete: PropTypes.func,
  handleQuantityChange: PropTypes.func,
};

export default connect(mapStateToProps, mapDispatchToProps)(withRouter(RefundLines));
